const PROTO_PARALLAX_LEADERBOARD_ENABLED_PAGES = new Set([
    "phx-citylab",
    "phx-citylab-design",
    "phx-citylab-culture",
    "phx-citylab-transportation",
    "phx-citylab-environment",
    "phx-citylab-economy",
    "phx-citylab-housing",
    "phx-citylab-justice",
    "phx-citylab-government",
    "phx-citylab-technology",
    "citylab",
    "citylab-design",
    "citylab-culture",
    "citylab-transportation",
    "citylab-environment",
    "citylab-economy",
    "citylab-housing",
    "citylab-justice",
    "citylab-government",
    "citylab-technology",
]);

export default function isProtoParallaxLeaderboardEnabled(
    pageInfo: string | undefined
): boolean {
    if (!pageInfo) {
        return false;
    }
    return PROTO_PARALLAX_LEADERBOARD_ENABLED_PAGES.has(pageInfo);
}
